import type { HelpFile } from '../../types/help'
import { ConnectorLogViewTestIds } from '../../../testids/ConnectorLogViewTestIds'

export const connectorLogViewHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorLogViewTestIds.cardTitleRecentActivity]: 'Aktuelle Konnektor-Aktivität — Provisionierungsaufrufe, Synchronisationsvorgänge und deren Ergebnisse.',
    [ConnectorLogViewTestIds.btnRefreshLogs]: null,
    [ConnectorLogViewTestIds.colDuration]: null,
    [ConnectorLogViewTestIds.colOperation]: 'Art des ausgeführten Vorgangs (Provisionierung, Entfernung, Synchronisation usw.).',
    [ConnectorLogViewTestIds.colStatus]: null,
    [ConnectorLogViewTestIds.colTimestamp]: null,
  },
}
